<template>
	<div class="operationalOverview">
		<div class="itemTitleBox disBetween">
			<span class="title">运营概况</span>
			<div class="tabBox disStart">
				<span class="disCenter" :class="{datatype:typeActive==2}" @click="typeActive=2">运营商</span>
				<span class="disCenter" :class="{datatype:typeActive==1}" @click="typeActive=1">地区</span>
			</div>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="disBetween searchLeft">
					<div class="myinputBox" v-if="typeActive==1">
						<el-cascader clearable ref="cascader1" placeholder="请选择地区"
							:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}" v-model="areaValue"
							:options="areaList" @change="handleChange($event,1)">
						</el-cascader>
					</div> 
					<div class="myinputBox" v-if="typeActive==2 && !($serviceProviderId)">
						<el-select clearable v-model="searchObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
							<el-option v-for="(item,inx) in serviceList" :key="inx" :label="item.serviceProviderName"
								:value="item.serviceProviderId"></el-option>
						</el-select>
					</div>
					<!-- <div class="myinputBox">
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.communityId" filterable remote reserve-keyword
								placeholder="请输入用户名称" :remote-method="remoteMethod" @change="changeSelect">
								<el-option v-for="item in restaurants" :key="item.communityId"
									:label="item.communityName" :value="item.communityId">
								</el-option>
							</el-select>
						</div>
					</div> -->
					<div class="timeType disStart">
						<span class="disCenter" :class="{active:active==1}" @click="active=1">日</span>
						<span class="disCenter" :class="{active:active==2}" @click="active=2">月</span>
					</div>
					<div class="myinputBox myinputBox2">
						<el-date-picker v-show="active==1" v-model="searchData" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期">
						</el-date-picker>
						<el-date-picker v-show="active==2" v-model="searchMonth" value-format="yyyy-MM" type="month"
							placeholder="选择日期">
						</el-date-picker>
					</div>
					<el-button type="success" @click="toSearch">查询</el-button>
				</div>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;">
				<div class="dataBox disStart">
					<div class="dataItem">
						<span>充电次数</span>
						<span class="num clickUndline" @click="showEchartDia(1,'充电次数')">{{dataObj.dataNum}}</span>
						<span>次</span>
					</div>
					<div class="dataItem">
						<span>充电收入</span>
						<span class="num clickUndline" @click="showEchartDia(2,'充电收入')">{{dataObj.income}}</span>
						<span>元</span>
					</div>
				</div>
				<div class="content myTable">
					<div class="titleBox">地区运营数据列表</div>
					<el-table :data="tableData" stripe style="width: 100%" v-loading="loading">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column v-if="typeActive==1" show-overflow-tooltip prop="rechargeTime" label="地区"
							width="180">
							<template slot-scope="scope">
								<span>{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}</span>
							</template>
						</el-table-column>
						<el-table-column v-if="typeActive==2" prop="serviceProviderName" label="运营商" width="180">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityCount" label="服务社区数量">
							<template slot-scope="scope">
								<span @click="showPower(scope.row,1)"
									class="clickUndline">{{scope.row.communityCount}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentCount" label="设备数量">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeCount" label="充电次数">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeAmount" label="充电收入">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="title1" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogOperation1" width="80%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disBetween">
					<div class="myinputBox">
						<el-select clearable v-model="searchObj1.communityId" slot="prepend" placeholder="请选择社区">
							<el-option v-for="(item,inx) in communityList" :key="inx" :label="item.communityName"
								:value="item.communityId"></el-option>
						</el-select>
						<!-- <el-select v-model="searchObj1.serviceProviderId" placeholder="请选择" filterable clearable
							v-el-select-loadmore="loadmore">
							<el-option v-for="item in communityList" :key="item.communityId" :label="item.communityName"
								:value="item.communityId">
							</el-option>
						</el-select> -->
					</div>
					<div class="timeType disStart">
						<span class="disCenter" :class="{active:active1==1}" @click="active1=1">日</span>
						<span class="disCenter" :class="{active:active1==2}" @click="active1=2">月</span>
					</div>
					<div class="myinputBox myinputBox2">
						<el-date-picker v-show="active1==1" :clearable="NOfalse" :editable="NOfalse"
							v-model="searchData1" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
						</el-date-picker>
						<el-date-picker v-show="active1==2" :clearable="NOfalse" :editable="NOfalse"
							v-model="searchMonth1" value-format="yyyy-MM" type="month" placeholder="选择日期">
						</el-date-picker>
					</div>
					<el-button type="success" @click="getoperationData(1)">查询</el-button>
				</div>
				<div class="myTable myTable2" v-loading="loading1">
					<el-table :data="operationData1" style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentCount" label="设备数量">
							<template slot-scope="scope">
								<span @click="showPower(scope.row,2)"
									class="clickUndline">{{scope.row.equipmentCount}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="serviceProviderName" label="运营商">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeCount" label="充电次数(次)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeAmount" label="充电收入(元)">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo1.pagesize"
						:current-page="OperationInfo1.pagenum" :total="OperationInfo1.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,1)">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation1 = false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="title2" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogOperation2" width="80%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disBetween">
					<div class="myinputBox">
						<el-select clearable v-model="searchObj2.communityEquipmentId" slot="prepend"
							placeholder="请选择设备">
							<el-option v-for="(item,inx) in equipmentList" :key="inx" :label="item.communityEquipmentNo"
								:value="item.communityEquipmentId"></el-option>
						</el-select>
					</div>
					<div class="timeType disStart">
						<span class="disCenter" :class="{active:active2==1}" @click="active2=1">日</span>
						<span class="disCenter" :class="{active:active2==2}" @click="active2=2">月</span>
					</div>
					<div class="myinputBox myinputBox2">
						<el-date-picker v-show="active2==1" v-model="searchData2" :clearable="NOfalse"
							:editable="NOfalse" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
						</el-date-picker>
						<el-date-picker v-show="active2==2" v-model="searchMonth2" :clearable="NOfalse"
							:editable="NOfalse" value-format="yyyy-MM" type="month" placeholder="选择日期">
						</el-date-picker>
					</div>
					<el-button type="success" @click="getoperationData(2)">查询</el-button>
				</div>
				<div class="myTable myTable2">
					<el-table :data="operationData2" style="width: 100%" v-loading="loading2">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeCount" label="充电次数(次)">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="rechargeAmount" label="充电收入(元)">
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo2.pagesize"
						:current-page="OperationInfo2.pagenum" :total="OperationInfo2.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,2)">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation2 = false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="echartsTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="showPowerEcharts" width="90%">
			<div class="dialogBox1">
				<div class="disStart">
					<div class="diaItem ">
						<div class="timeType disStart">
							<span class="disCenter" :class="{active:active3==1}" @click="active3=1">月</span>
							<span class="disCenter" :class="{active:active3==2}" @click="active3=2">年</span>
						</div>
						<div class="myinputBox myinputBox2">
							<el-date-picker v-show="active3==1" :clearable="NOfalse" :editable="NOfalse"
								v-model="searchMonth3" value-format="yyyy-MM" type="month" placeholder="选择日期">
							</el-date-picker>
							<el-date-picker v-show="active3==2" :clearable="NOfalse" :editable="NOfalse"
								v-model="searchYear3" value-format="yyyy" type="year" placeholder="选择日期">
							</el-date-picker>
						</div>
						<el-button type="success" @click="getEcharts">查询</el-button>
					</div>
				</div>
				<div v-loading="echartLoading" class="statisticalRight" id="myEcharts2"></div>
			</div>
		</el-dialog>
	</div>

</template>

<script type="text/javascript">
	import {
		timestampToDate,
		timestampToyesterdayDate
	} from "../../../../assets/js/common.js"
	var token = localStorage.getItem('token')
	export default {
		name: "chargingRecord",
		components: {},
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					// 获取element-ui定义好的scroll盒子
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						/**
						 * scrollHeight 获取元素内容高度(只读)
						 * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
						 * clientHeight 读取元素的可见高度(只读)
						 * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
						 * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
						 */
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		data() {
			return {
				formData: {
					pageNo: 1, //当前页
					pageSize: 8, //当
				},
				PageInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				tableData: [],
				total: 0,
				active: 1,

				typeActive: 2,
				timeDate: "date",
				searchData: "",
				searchMonth: "",
				dataObj: {
					dataNum: "",
					income: ""
				},
				serviceList: [],
				searchObj: {
					provinceCode: "", //省
					cityCode: "", //市
					areaCode: "", //区
					dateType: "1", //1日 2月
					dateFormat: "", //日期格式 （2023-05-30）或者（2023-05）
					dataType: "2", //1地区 2运营商
					pageNo: 1, //当前页
					pageSize: 8, //当前页个数
					userName: "", //用户名称
				},

				searchObj2: {
					communityId: "",
					communityEquipmentId: "",
					dateType: "",
					date: "",
					pageNo: 1,
					pageSize: 8,
				},
				operationData: [],
				NOfalse: false,
				loading: false,
				loading1: false,
				loading2: false,
				dialogOperation1: false,
				areaList: [],
				areaValue: "",
				restaurants: [],
				options: [],
				communityList: [],
				title1: "",
				active1: 1,
				searchData1: "",
				searchMonth1: "",
				operationData1: [],
				searchObj1: {
					communityId: "",
					provinceCode: "",
					cityCode: "",
					areaCode: "",
					dateType: "",
					date: "",
					pageNo: 1,
					pageSize: 8,
					serviceProviderId: ""
				},
				OperationInfo1: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				equipmentList: [],
				title2: "",
				active2: 1,
				searchData2: "",
				searchMonth2: "",
				operationData2: [],
				OperationInfo2: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				dialogOperation2: false,
				echartLoading: false,
				showPowerEcharts: false,
				active3: 1,
				echartsTitle: "",
				searchMonth3: "",
				searchYear3: "",
				echartTypye: 1,
				end: 0,
				min: 0
			}
		},
		watch: {
			typeActive(n) {
				this.searchObj.dataType = n
				this.$nextTick(() => {
					this.getData()
				})
			}
		},
		mounted() {
			if (!(localStorage.getItem("areaList"))) {
				this.getAreaList()
			} else {
				this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
			}
			this.selectParamConfigByCode()
			this.searchData = timestampToDate(new Date())
			this.searchData1 = timestampToyesterdayDate(new Date())
			this.searchData2 = timestampToyesterdayDate(new Date())
			this.$set(this, "searchMonth", timestampToyesterdayDate(new Date()).slice(0, 7))
			this.$set(this, "searchMonth1", timestampToyesterdayDate(new Date()).slice(0, 7))
			this.$set(this, "searchMonth2", timestampToyesterdayDate(new Date()).slice(0, 7))
			this.$set(this, "searchMonth3", timestampToyesterdayDate(new Date()).slice(0, 7))
			this.$set(this, "searchYear3", timestampToDate(new Date()).slice(0, 4))
			this.$nextTick(() => {
				this.getData()
			})
		},
		methods: {
			showEchartDia(n, str) {
				this.active3 = 1
				this.echartTypye = n
				this.echartsTitle = str + "曲线图"
				this.getEcharts()
			},
			getEcharts() {
				this.echartLoading = true
				let time = ""
				if (this.active3 == 1) {
					time = this.searchMonth3
				} else {
					time = this.searchYear3
				}
				let item = {
					xDate: [],
					data: []
				}
				let arr = []
				this.showPowerEcharts = true
				if (this.echartTypye == 1) {
					this.$api.selectOrderCountByServiceProviderAndDateType({
						dateType: this.active3,
						date: time,
						serviceProviderId: this.typeActive == 2 ? (this.searchObj.serviceProviderId || "") :
							"",
						// areaCode: this.typeActive == 1 ? (this.searchObj1.areaCode || "") : "",
						// cityCode: this.typeActive == 1 ? (this.searchObj1.cityCode || "") : "",
						// provinceCode: this.typeActive == 1 ? (this.searchObj1.provinceCode || "") : "",
					}).then((res) => {
						if (res.returnCode == 200) {
							this.echartLoading = false
							if (res.obj.orderList && res.obj.orderList.length > 0) {
								this.showPowerEcharts = true
								for (let k in res.obj.dateList) {
									if (this.active3 == 1) {
										this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "号")
									} else {
										this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "月")
									}
								}
								this.$set(item, "xDate", res.obj.dateList || [])
								this.$set(item, "data", res.obj.orderList || [])
								this.$nextTick(() => {
									this.showEchart(item)
								})
							}
						}
					})
				} else {
					this.$api.selectOrderAmountByServiceProviderAndDateType({
						dateType: this.active3,
						date: time,
						serviceProviderId: this.typeActive == 2 ? (this.searchObj.serviceProviderId || "") :
							"",
						// areaCode: this.typeActive == 1 ? (this.searchObj1.areaCode || "") : "",
						// cityCode: this.typeActive == 1 ? (this.searchObj1.cityCode || "") : "",
						// provinceCode: this.typeActive == 1 ? (this.searchObj1.provinceCode || "") : "",
					}).then((res) => {
						if (res.returnCode == 200) {
							this.echartLoading = false
							if (res.obj.orderAmountList && res.obj.orderAmountList.length > 0) {
								this.showPowerEcharts = true
								for (let k in res.obj.dateList) {
									if (this.active3 == 1) {
										this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "号")
									} else {
										this.$set(res.obj.dateList, [k], res.obj.dateList[k] + "月")
									}
								}
								this.$set(item, "xDate", res.obj.dateList || [])
								this.$set(item, "data", res.obj.orderAmountList || [])
								this.$nextTick(() => {
									this.showEchart(item)
								})
							}
						}
					})
				}
			},
			showEchart(item) {
				let that = this
				let getchart = that.$echarts.init(document.getElementById('myEcharts2'));
				getchart.clear()
				var option = {
					tooltip: {
						trigger: "axis",
						valueFormatter: function(value) {
							return value + (that.echartTypye == 1 ? "次" : "元")
						}
					},
					grid: {
						top: "8%",
						left: "1%",
						right: "4%",
						bottom: "8%",
						containLabel: true,
					},
					xAxis: [{
						type: "category",
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},
						splitLine: {
							show: false,
						},

						splitArea: {
							show: false,
						},
						data: item.xDate,
					}, ],
					yAxis: [{
						name: that.echartTypye == 1 ? "次" : "元",
						type: "value",
						// min: that.min,
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},

					}, ],
					// dataZoom: [{
					// 		show: true,
					// 		height: 30,
					// 		xAxisIndex: [0],
					// 		bottom: -60,
					// 		start: 0,
					// 		end: that.end,
					// 	},
					// 	{
					// 		type: "inside",
					// 		show: true,
					// 		height: 15,
					// 		start: 1,
					// 		end: 50,
					// 	},
					// ],
					series: [{
						name: that.echartTypye == 1 ? "充电次数" : "充电收入",
						type: "line",
						smooth: true, //是否平滑曲线显示
						symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
						symbolSize: 10,
						lineStyle: {
							normal: {
								color: "#03adac", // 线条颜色
							},
						},
						data: item.data,
					}, ],
				};

				that.$nextTick(() => {
					getchart.setOption(option);
				})
			},
			// loadmore() {
			// 	this.formData.pageNo++;
			// 	this.getList(this.formData);
			// },
			// 弹窗下拉框 社区1 设备2
			getList(obj, n) {
				if (n == 1) {
					// 社区弹窗下拉框 2运营商 1地区
					if (this.typeActive == 2) {
						let item = {
							serviceProviderId: obj.serviceProviderId,
						}
						this.$api.listAllCommunityByServiceProviderId(item).then((res) => {
							if (res.returnCode == 200) {
								this.$set(this, "communityList", res.obj)
							}
						})
					} else {
						let item = {
							provinceCode: obj.provinceCode,
							cityCode: obj.cityCode,
							areaCode: obj.areaCode,
						}
						this.$api.listAllCommunityByAreaCode(item).then((res) => {
							if (res.returnCode == 200) {
								this.$set(this, "communityList", res.obj)
							}
						})
					}


				} else {
					let item = {
						communityId: obj.communityId,
					}
					this.$api.listAllEquipmentByCommunityId(item).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "equipmentList", res.obj)
						}
					})
				}
			},
			// 弹窗 社区1 设备2
			showPower(obj, n) {
				if (n == 1) {
					this.$set(this, "communityList", [])
					this.$set(this, "active1", 1)
					this.$set(this.searchObj1, "communityId", "")
					this.getList(obj, n)
					if (this.typeActive == 2) { //2运营商 1地区
						this.$set(this.searchObj1, "serviceProviderId", obj.serviceProviderId)
						this.$set(this, "title1", "运营商(" + obj.serviceProviderName + ")-社区运营情况")
					} else {
						this.$set(this.searchObj1, "areaCode", obj.areaCode)
						this.$set(this.searchObj1, "cityCode", obj.cityCode)
						this.$set(this.searchObj1, "provinceCode", obj.provinceCode)
						this.$set(this, "title1", (obj.provinceName + obj.cityName + obj.areaName) + "-社区运营情况")
					}
					this.getAreaCont()
					this.dialogOperation1 = true
				} else {
					this.$set(this, "active2", 1)
					this.$set(this.searchObj2, "communityEquipmentId", "")
					this.$set(this, "equipmentList", [])
					this.$set(this, "title2", "运营商(" + obj.serviceProviderName + ")-设备运营情况")
					this.$set(this.searchObj2, "communityId", obj.communityId)
					this.searchData2 = timestampToyesterdayDate(new Date())
					this.getList(obj, n)
					this.getEquList()
					this.dialogOperation2 = true
				}
			},
			// 设备弹窗列表
			getEquList() {
				this.loading2 = true
				if (this.active2 == 1) {
					this.searchObj2.dateType = 1
					this.searchObj2.date = this.searchData2
				} else {
					this.searchObj2.dateType = 2
					this.searchObj2.date = this.searchMonth2
				}
				this.$api.listEquipmentByCommunityId(this.searchObj2).then((res) => {
					this.loading2 = false
					this.$set(this, "operationData2", res.obj.list)
					this.$set(this.OperationInfo2, "total", res.obj.total)
				})
			},
			// 社区弹窗列表
			getAreaCont() {
				this.loading1 = true
				let obj = {
					communityId: this.searchObj1.communityId,
					dateType: "",
					date: "",
					pageNo: this.searchObj1.pageNo,
					pageSize: this.searchObj1.pageSize,
				}
				if (this.active1 == 1) {
					obj.dateType = 1
					obj.date = this.searchData1
				} else {
					obj.dateType = 2
					obj.date = this.searchMonth1
				}
				// 根据运营商查询2 根据地区查询1
				if (this.typeActive == 2) {
					obj.serviceProviderId = this.searchObj1.serviceProviderId
					this.$nextTick(() => {
						this.$api.listCommunityByServiceProviderId(obj).then((res) => {
							if (res.returnCode == 200) {
								this.loading1 = false
								if (this.typeActive == 2) {
									this.$set(this, "communityList", res.obj.list)
								}
								this.$set(this, "operationData1", res.obj.list)
								this.$set(this.OperationInfo1, "total", res.obj.total)
							}
						})
					})
				} else {
					obj.provinceCode = this.searchObj1.provinceCode
					obj.cityCode = this.searchObj1.cityCode
					obj.areaCode = this.searchObj1.areaCode
					this.$nextTick(() => {
						this.$api.listCommunityByAreaCode(obj).then((res) => {
							if (res.returnCode == 200) {
								this.loading1 = false
								if (this.typeActive == 2) {
									this.$set(this, "communityList", res.obj.list)
								}
								this.$set(this, "operationData1", res.obj.list)
								this.$set(this.OperationInfo1, "total", res.obj.total)
							}
						})
					})
				}
			},
			// 弹窗查询
			getoperationData(n) {
				if (n == 1) {
					this.$set(this.OperationInfo1, "pagenum", 1)
					this.$set(this.searchObj1, "pageNo", 1)
					this.getAreaCont()
				} else {
					this.$set(this.OperationInfo2, "pagenum", 1)
					this.$set(this.searchObj2, "pageNo", 1)
					this.getEquList()
				}
			},
			// 弹窗分页
			handleCurrentChange2(val, n) {
				this.$nextTick(() => {
					if (n == 1) {
						this.$set(this.OperationInfo1, "pagenum", val)
						this.$set(this.searchObj1, "pageNo", val)
						this.getAreaCont()
					} else if (n == 2) {
						this.$set(this.OperationInfo2, "pagenum", val)
						this.$set(this.searchObj2, "pageNo", val)
						this.getEquList()
					}
				})
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})

			},
			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "serviceList", res.obj || [])
					}
				})

			},
			changeSelect(n) {
				this.$set(this.searchObj, "communitySiteId", "")
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);
						}
					})
				} else {
					this.options = [];
				}
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				})
				return obj.text
			},
			toSearch() {

				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.$nextTick(() => {
					this.getData()
				})
			},
			// 省市区联动
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
				} else {
					this.$set(this.searchObj, "provinceCode", "")
					this.$set(this.searchObj, "cityCode", "")
					this.$set(this.searchObj, "areaCode", "")
				}

			},
			getData() {
				this.loading = true
				if (this.active == 1) {
					this.searchObj.dateType = 1
					this.searchObj.dateFormat = this.searchData
				} else {
					this.searchObj.dateType = 2
					this.searchObj.dateFormat = this.searchMonth
				}
				this.$api.listOperationalData(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this.PageInfo, "total", res.obj.total)
						this.$set(this, "tableData", res.obj.list)
					}
					this.loading = false
				})
				let obj = {
					provinceCode: this.searchObj.provinceCode, //省
					cityCode: this.searchObj.cityCode, //市
					areaCode: this.searchObj.areaCode, //区
					dataType:this.searchObj.dataType,
					dateType: this.searchObj.dateType, //1日 2月
					dateFormat: this.searchObj.dateFormat, //日期格式 （2023-05-30）或者（2023-05）
				}
				this.$api.operationOverview(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this.dataObj, "dataNum", res.obj.rechargeCount)
						this.$set(this.dataObj, "income", res.obj.rechargeAmount)
					}
				})

			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData()
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./operationalOverview.scss"
</style>